/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_SkillsInputs */

const en_mk_shot_skills = /** @type {(inputs: Mk_Shot_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Skill editor: a way of working written once and reused by every agent.`)
};

const id_mk_shot_skills = /** @type {(inputs: Mk_Shot_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor Skill: instruksi cara kerja yang ditulis sekali lalu dipakai ulang oleh setiap agen.`)
};

/**
* | output |
* | --- |
* | "The Skill editor: a way of working written once and reused by every agent." |
*
* @param {Mk_Shot_SkillsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_skills = /** @type {((inputs?: Mk_Shot_SkillsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_SkillsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_skills(inputs)
	return en_mk_shot_skills(inputs)
});